import { updateManagerPageStep } from "./managerPageWizardService";
import apiClient from "./ApiService";
/**
 * Convierte un archivo a Base64 (sin encabezado)
 */
const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

/**
 * Guarda los archivos del paso FILES
 * - Convierte archivos a Base64
 * - Envía al backend
 * - Actualiza ManagerPage
 */
export const saveFilesStep = async ({ idTransaction, data }) => {
  //Convertir archivos
  const base64Interior = await fileToBase64(data.interiorPhoto);
  const base64Front = await fileToBase64(data.frontPhoto);
  const base64Inventory = await fileToBase64(data.inventoryPhoto);
  const base64Document = await fileToBase64(data.document);

  //Armar DTO
  const dto = {
    idAdmin: idTransaction,
    images: [
      base64Interior,
      base64Front,
      base64Inventory,
      base64Document
    ]
  };

  //Guardar archivos
  try {
    const { data: result } = await apiClient.post(
      "/adelselfservice/selfservice/files",
      dto
    );

    await updateManagerPageStep(idTransaction, "files");

    return result;
  } catch (e) {
    console.error(e)
  }
};

export async function getFilesStep(idAdmin) {
  try {
    const data  = await apiClient.get(
      `/adelselfservice/selfservice/files/admin/${idAdmin}`
    );

    return data;
  } catch (e) {
    console.error(e)
  }
}